'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function srcCategoryNode() {
    return {
        restrict: 'A',
        template: require('../view/src-category-node.html'),
        controller: ['$scope',
            function ($scope,) {

                $scope.isOpen = has($scope.selectedItem, $scope.item);

                function has(selectedItem, item) {
                    if (item == null) {
                        return false;
                    }
                    if (angular.equals(item, selectedItem)) {
                        return true;
                    }
                    let eq = false;
                    for (let i = 0; item.nodes != null && i < item.nodes.length; ++i) {
                        eq = eq || has(selectedItem, item.nodes[i]);
                    }
                    return eq;
                }

                $scope.$on("updateStateNode", function (event, _data) {
                    $scope.isOpen = has($scope.selectedItem, $scope.item);
                });

            }]
    };
}
